import classNames from "classnames/bind";
import React from "react";
import styles from "../DropdownInput.module.scss";
import { useDropdownContext } from "../DropdownContext";

const cx = classNames.bind(styles);

export type DropdownChipProps = {
  chipValue: any;
};

const DropdownChip = ({ chipValue }: DropdownChipProps) => {
  const { getLabel, getValue, isLoading } = useDropdownContext();

  return (
    <div
      key={`${getValue?.(chipValue)}-chip`}
      className={cx("chip", { isLoading })}
    >
      {getLabel?.(chipValue)}
    </div>
  );
};

export default DropdownChip;
